import React, { useState, useEffect, useRef } from 'react';
import RegistrationForm from '../components/registration/registrationForm2';
import RegistrationMini from '../components/registration/registrationMini';
import { useSearchParams } from 'react-router-dom';
import { Box, useToast } from '@chakra-ui/react';
import apiEndpoint from '../components/config/data';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import SplashScreen from '../components/splashScreen/SplashScreen';

const Register = ({ flags }) => {
  const [searchParams] = useSearchParams();
  const hasRun = useRef(false);
  const toast = useToast();
  const [state, setState] = useState({
    mini: false, //Mini is the first step in the registration process (Company name + email)
    signedUp: false,
    code: null, //Unique ID that will identify the company that is emailed to them after the first part of the flow
    companyName: '',
    companyEmail: '',
  });

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    // const queryParameters = new URLSearchParams(window.location.search);
    const code = searchParams.get('code');

    if (code === null) {
      setState(prev => ({ ...prev, mini: true }));
    } else {
      const formData = new FormData();
      formData.append('token', code);
      fetch(apiEndpoint + '/api/verifyCode/', {
        method: 'POST',
        body: formData,
      })
        .then(response => response.json())
        .then(data => {
          if (data['verified'] === 'pass') {
            setState(prev => ({
              ...prev,
              signedUp: true,
              code: code,
              companyName: data['companyName'],
              companyEmail: data['companyEmail'],
              blid: data['blid'],
              firstName: data['firstName'],
              lastName: data['lastName'],
              zipCode: data['zipCode'],
              phone: data['phone'],
              accounting_software: data['accounting_software'],
            }));
          } else {
            toast({
              title: 'Link Expired',
              description:
                'The registration link has expired. Please request a new one.',
              status: 'error',
              duration: 5000,
              isClosable: true,
              position: 'top',
            });
            setState(prev => ({ ...prev, mini: true }));
          }
        })
        .catch(() => {
          toast({
            title: 'Link Expired', //This might not be the the most accurate message
            description:
              'The registration link has expired. Please request a new one.',
            status: 'error',
            duration: 5000,
            isClosable: true,
            position: 'top',
          });
          setState(prev => ({ ...prev, mini: true }));
        });
    }
  }, [searchParams, toast]);

  const showReskin = flags.showReskin;

  if (showReskin) {
    return (
      <SplashScreen
        contentProps={{
          currentView: 'register',
          companyData: {
            companyName: state.companyName,
            // companyName: 'Frozen Grapes', //For testing purposes
            companyEmail: state.companyEmail,
            signedUp: state.signedUp,
            // signedUp: true,
            code: state.code, // Include the code parameter from the URL
            blid: state.blid,
            firstName: state.firstName,
            lastName: state.lastName,
            zipCode: state.zipCode,
            phone: state.phone,
            accounting_software: state.accounting_software,
          },
        }}
      />
    );
  }
  return (
    <Box>
      {state.mini && <RegistrationMini />}
      {state.signedUp && (
        <RegistrationForm
          code={state.code}
          companyName={state.companyName}
          companyEmail={state.companyEmail}
          blid={state.blid}
          firstName={state.firstName}
          lastName={state.lastName}
          zipCode={state.zipCode}
          phone={state.phone}
          accounting_software={state.accounting_software}
        />
      )}
    </Box>
  );
};

export default withLDConsumer()(Register);
